module.exports = __webpack_public_path__ + "img/news-image-review1.bbc135bc.png";